import {Icon} from '@wandb/weave/components/Icon';
import {LoadingDots} from '@wandb/weave/components/LoadingDots';
import React from 'react';

import {StatItemProps} from '../types';

export const StatItem: React.FC<StatItemProps> = ({
  label,
  value,
  loading = false,
  icon,
}) => {
  return (
    <div className="flex flex-col items-center gap-8 sm:gap-10">
      <div className="flex items-center justify-center gap-4 text-[10px] font-medium uppercase tracking-wide text-moon-500 sm:gap-6 sm:text-xs">
        {icon && (
          <Icon
            name={icon}
            width={12}
            height={12}
            className="text-moon-400 sm:h-[14px] sm:w-[14px]"
          />
        )}
        <span>{label}</span>
      </div>
      <div className="text-center text-xl font-bold text-moon-900 sm:text-2xl lg:text-3xl">
        {loading ? <LoadingDots /> : value}
      </div>
    </div>
  );
};
